angular.module('unica_feedback.feedback_controllers')

.controller('FeedbackListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	FeedbackListService, FeedbackDeleteService, FeedbackEditService
) {

	$scope.feedbackList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.category_id = $stateParams.category_id;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationType = null;
	$scope.$on('event_loaded', function() {
		$scope.notificationType = $rootScope.eventData.notification_type;
	});

	$scope.tiles = [];

	$scope.loadFeedbacks = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		FeedbackListService
			.list( $stateParams.category_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.feedbackList = $scope.feedbackList.concat( data );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadFeedbacks();

	$scope.openFeedbackModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalFeedbackInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/feedback.html',
			size: 'lg',
			windowClass: 'modal-feedback'
		});

		modalInstance.result.then(function (data) {
			$scope.loadFeedbacks();
		}, function () { });
	};

	$scope.notifyFeedback = function() {
		$confirm({
			title: 'Sei sicuro di voler procedere con l\'invio delle notifiche?',
			text: 'Confermi l\'invio delle notifiche (' + $scope.notificationType + ') a tutti coloro che hanno avuto una risposta?'
		}).then(function() {

			$scope.showLoader();
			FeedbackEditService
				.sendNotifications( { category_id: $scope.category_id, invitation_list_id: $scope.invitation_list_id }  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						// I non raggiungibili sono quelli che non hanno numero impostato o non hanno l'app
						$scope.showSuccessMsg(
							'Invio di ' + data.notifiche +  ' notifiche ' + data.type + ' avviato con successo!' +
							' (' + data.not_defined + ' non raggiungibili)', ''
						);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.deleteFeedback = function(feedbackId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il feedback?',
			text: 'Confermi la cancellazione del feedback?'
		}).then(function() {

			$scope.showLoader();
			FeedbackDeleteService
				.delete( feedbackId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.feedbackList, function(feedback, key) {
							if ( feedback.id == feedbackId ) {
								$scope.feedbackList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Feedback eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.showDelete = true;
	if ( sessionStorage.getItem('from_admin_archive') ) {
		sessionStorage.removeItem('from_admin_archive');
		$scope.showDelete = false;
	}

	$scope.downloadExportFeedback = false;
	$scope.exportFeedbackUrl      = '';

	$scope.prepareFeedbackExportUrl = function()
	{
		$scope.showLoader();
		FeedbackListService
			.exportFeedbackCategory( $stateParams.category_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportFeedback = true;
					$scope.exportFeedbackUrl      = url;
				}
			});
	};

	$scope.downloadExportAudioZip = false;
	$scope.exportAudioZipUrl      = '';
	$scope.prepareAudioZip = function()
	{
		$scope.showLoader();
		FeedbackListService
			.exportAudioZip( $stateParams.event_id, $stateParams.category_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportAudioZip = true;
					$scope.exportAudioZipUrl      = url;
				}
			});

	};

})


.controller('ModalFeedbackInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.feedbackData = {
		files: []
	};

	$scope.uploadDone = false;

	$scope.uploader = new FileUploader({
		alias: 'files',
		url: getBaseApiURL + '/feedback/upload',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.formData.push({ 'event_id' : $stateParams.event_id });

	$scope.uploader.onCompleteAll = function() {
		$scope.uploadDone = true;
	};

	$scope.createFeedbacks = function () {
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		if ( $scope.uploadDone ) {
			$uibModalInstance.close();
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	};

	$scope.triggerInput = function() {
		setTimeout(function() {
			document.getElementById('files').click()
		}, 0);
	};

});